// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  font-family: Helvetica;
  font-size: 1.5625rem;
  font-weight: 400;
  background: #150f2c;
  padding: 60px 0px;
}
.footer_container {
  background: #fff5f2;
  align-content: center;
}
.footer_headings1 {
  color: var(--orange-0, #f0592a);
  font-size: 3.247631935vh;
  font-style: normal;
  font-weight: 400;
  line-height: 200%;
  text-decoration: none;
}
@media (max-width: 992px) {
  .footer_headings1 {
    font-size: 2.2vh;
  }
}
.footer_headings2 {
  color: var(--orange-0, #f0592a);
  font-size: 3.247631935vh;
  font-style: normal;
  font-weight: 400;
  line-height: 200%;
  text-decoration: none;
}
@media (max-width: 992px) {
  .footer_headings2 {
    font-size: 2.2vh;
  }
}
.footer_headings3 {
  color: var(--orange-0, #f0592a);
  font-size: 3.247631935vh;
  font-style: normal;
  font-weight: 400;
  line-height: 200%;
  text-decoration: none;
}
@media (max-width: 1200px) {
  .footer_headings3 {
    font-size: 3.4vh;
  }
}
@media (max-width: 992px) {
  .footer_headings3 {
    font-size: 2.2vh;
  }
}
@media only screen and (min-width: 800px) and (max-width: 1200px) {
  .footer_headings3Col {
    margin-top: 3vh;
  }
}
@media only screen and (min-width: 800px) and (max-width: 911px) {
  .footer_headings2Col {
    margin-top: 3vh;
  }
}
.footer_subHeadingsDiv {
  margin-bottom: 1.125rem;
}
.footer_subHeadings {
  color: #fff;
  font-size: 2.4357239513vh;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  text-decoration: none;
}
@media (max-width: 1200px) {
  .footer_subHeadings {
    font-size: 2.2vh;
  }
}
@media (max-width: 992px) {
  .footer_subHeadings {
    font-size: 1.8vh;
  }
}
.footer_address {
  line-height: 1.5rem;
}
.footer_lastcol {
  margin-top: 0.5rem;
}
.footer_ntLogo {
  width: 10.7572916667vw;
  height: 22.649120433vh;
}

.footerCol {
  border: none;
  color: "#FFF";
  margin-top: 9vh;
}

.footerColChild {
  color: #fff;
}

.footerColChild h1 {
  line-height: 2rem;
}

.footerColChild p {
  line-height: 90%;
}

.col_align {
  text-align: start;
}

@media (max-width: 769px) {
  .footer {
    padding-left: 20px;
  }
  .col_align {
    margin-bottom: 35px;
  }
  .footerColChild {
    margin-bottom: 35px;
  }
  .datacol {
    margin-bottom: 30px;
  }
}
.menu-text-decoration:hover {
  color: #f0592a !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/Layouts/Footer/footer.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AACF;AACE;EACE,mBAAA;EACA,qBAAA;AACJ;AAEE;EACE,+BAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAEA,qBAAA;AADJ;AAII;EAVF;IAWI,gBAAA;EADJ;AACF;AAKE;EACE,+BAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAEA,qBAAA;AAJJ;AAOI;EAVF;IAWI,gBAAA;EAJJ;AACF;AAQE;EACE,+BAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAEA,qBAAA;AAPJ;AAQI;EARF;IASI,gBAAA;EALJ;AACF;AAMI;EAXF;IAYI,gBAAA;EAHJ;AACF;AAMI;EADF;IAEI,eAAA;EAHJ;AACF;AAMI;EADF;IAEI,eAAA;EAHJ;AACF;AAME;EACE,uBAAA;AAJJ;AAOE;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAEA,qBAAA;AANJ;AAOI;EARF;IASI,gBAAA;EAJJ;AACF;AAKI;EAXF;IAYI,gBAAA;EAFJ;AACF;AAKE;EACE,mBAAA;AAHJ;AAME;EACE,kBAAA;AAJJ;AAOE;EACE,sBAAA;EACA,sBAAA;AALJ;;AASA;EACE,YAAA;EACA,aAAA;EAEA,eAAA;AAPF;;AAUA;EACE,WAAA;AAPF;;AAUA;EACE,iBAAA;AAPF;;AAUA;EACE,gBAAA;AAPF;;AAUA;EACE,iBAAA;AAPF;;AAUA;EACE;IACE,kBAAA;EAPF;EAUA;IACE,mBAAA;EARF;EAWA;IACE,mBAAA;EATF;EAWA;IACE,mBAAA;EATF;AACF;AAWA;EACE,yBAAA;AATF","sourcesContent":[".footer {\n  font-family: Helvetica;\n  font-size: 1.5625rem;\n  font-weight: 400;\n  background: #150f2c;\n  padding: 60px 0px;\n\n  &_container {\n    background: #fff5f2;\n    align-content: center;\n  }\n\n  &_headings1 {\n    color: var(--orange-0, #f0592a);\n    font-size: 3.2476319350473615vh;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 200%;\n    // text-transform: uppercase;\n    text-decoration: none;\n    @media (max-width: 1200px) {\n    }\n    @media (max-width: 992px) {\n      font-size: 2.2vh;\n    }\n    @media (max-width: 768px) {\n    }\n  }\n  &_headings2 {\n    color: var(--orange-0, #f0592a);\n    font-size: 3.2476319350473615vh;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 200%;\n    // text-transform: uppercase;\n    text-decoration: none;\n    @media (max-width: 1200px) {\n    }\n    @media (max-width: 992px) {\n      font-size: 2.2vh;\n    }\n    @media (max-width: 768px) {\n    }\n  }\n  &_headings3 {\n    color: var(--orange-0, #f0592a);\n    font-size: 3.2476319350473615vh;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 200%;\n    // text-transform: uppercase;\n    text-decoration: none;\n    @media (max-width: 1200px) {\n      font-size: 3.4vh;\n    }\n    @media (max-width: 992px) {\n      font-size: 2.2vh;\n    }\n  }\n  &_headings3Col {\n    @media only screen and (min-width: 800px) and (max-width: 1200px) {\n      margin-top: 3vh;\n    }\n  }\n  &_headings2Col {\n    @media only screen and (min-width: 800px) and (max-width: 911px) {\n      margin-top: 3vh;\n    }\n  }\n\n  &_subHeadingsDiv {\n    margin-bottom: 1.125rem;\n  }\n\n  &_subHeadings {\n    color: #fff;\n    font-size: 2.435723951285521vh;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 150%;\n    // text-transform: uppercase;\n    text-decoration: none;\n    @media (max-width: 1200px) {\n      font-size: 2.2vh;\n    }\n    @media (max-width: 992px) {\n      font-size: 1.8vh;\n    }\n  }\n\n  &_address {\n    line-height: 1.5rem;\n  }\n\n  &_lastcol {\n    margin-top: 0.5rem;\n  }\n\n  &_ntLogo {\n    width: 10.757291666666667vw;\n    height: 22.649120433017593vh;\n  }\n}\n\n.footerCol {\n  border: none;\n  color: \"#FFF\";\n\n  margin-top: 9vh;\n}\n\n.footerColChild {\n  color: #fff;\n}\n\n.footerColChild h1 {\n  line-height: 2rem;\n}\n\n.footerColChild p {\n  line-height: 90%;\n}\n\n.col_align {\n  text-align: start;\n}\n\n@media (max-width: 769px) {\n  .footer {\n    padding-left: 20px;\n  }\n\n  .col_align {\n    margin-bottom: 35px;\n  }\n\n  .footerColChild {\n    margin-bottom: 35px;\n  }\n  .datacol {\n    margin-bottom: 30px;\n  }\n}\n.menu-text-decoration:hover {\n  color: #f0592a !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
